//
// Overview.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "../core/styles/FillAttributes";
import "../core/styles/LineAttributes";
import "../core/Pad";
import "../core/HorizontalAlignment";
import "../core/VerticalAlignment";
import "@sas-dvr/ltjs-commons/util/Dimension";

var Overview = createModule("gtl::Overview", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        pad: 1,
        hAlign: 4,
        visible: 2,
        filterAttributes: 1,
        width: 1,
        borderAttributes: 1,
        backgroundAttributes: 1,
        vAlign: 4,
        viewportBorderAttributes: 1,
        height: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Overview;
